import React, { type ReactNode } from 'react';

import cx from '../../../utils/classNames';

import styles from '../button.module.scss';

/** Custom props */
type Props = {
  /** The content of the component */
  children?: ReactNode;
  /** Custom class to overwrite default styling if needed */
  className?: string;
} & React.HTMLAttributes<HTMLSpanElement>;

export function Label(props: Props) {
  const { children, className, ...rest } = props;

  const classNames = cx(styles.buttonLabel, className);

  return (
    <span className={classNames} data-testid="button-label" {...rest}>
      {children}
    </span>
  );
}

export default Label;
